import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export const useMobile = () => {
	const breakpoints = useBreakpoints(breakpointsTailwind)
	const isMobile = breakpoints.smaller('lg')
	const screenSizesBreak = reactive({
		lg: breakpoints.smaller('lg'),
		sm: breakpoints.smaller('sm'),
		md: breakpoints.smaller('md'),
		xl: breakpoints.smaller('xl'),
		xxl: breakpoints.smaller('2xl'),
		biggerThanLg: breakpoints.greaterOrEqual('lg'),
		biggerThanMd: breakpoints.greaterOrEqual('md')
	})
	const deviceType = ref<'tablet' | 'desktop' | 'mobile' | null>(null)
	const ua = (import.meta.client && navigator.userAgent) || ''
	if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua as string)) {
		deviceType.value = 'tablet'
	} else if (
		/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
			ua as string
		)
	) {
		deviceType.value = 'mobile'
	} else {
		deviceType.value = 'desktop'
	}
	return { isMobile, deviceType, screenSizesBreak }
}
